import Swal from 'sweetalert2';
import { SweetAlertIcon } from 'sweetalert2';

const useSwalToast = () => {
  // Função para exibir o toast com as props recebidas
    const showToast = (icon: SweetAlertIcon, title: string) => {
        Swal.fire({
        toast: true,
        position: 'top-end',
        icon,
        title,
        showConfirmButton: false,
        timer: 3000,
        timerProgressBar: true,
        didOpen: (toast) => {
            toast.addEventListener('mouseenter', Swal.stopTimer);
            toast.addEventListener('mouseleave', Swal.resumeTimer);
        },
        });
    };

    return { showToast };
};

export default useSwalToast;
